import PropTypes from "prop-types";

export default {
	data: PropTypes.object,
};
